import React from 'react'

function Electronic() {
  return (
    <div>
    <button className='peer text-white lg:text-gray-700 font-semibold lg:font-normal text-center text-md   lg:text-sm'  >Elektronik</button>
    <div className='hidden peer-hover:flex hover:flex absolute'>
      <div className='p-2 md:p-3 lg:p-4 z-20 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 border border-gray-400 lg:border-none mt-2 lg:mt-6 cursor-pointer w-80  md:w-97 text-center'>
          <div className='p-1 lg:p-2 space-x-2 grid grid-cols-2 md:grid-cols-4'>
              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Küçük Ev Aletleri</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Ütü</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Robot Süpürge</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Süpürge</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Çay Makinesi</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kahve Makinası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Blender</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tartı</li>
          
              </ul>

              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Bilgisayar & Tablet</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Monitör</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Yazıcı </li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tarayıcı </li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Laptop</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tablet</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Mouse</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Klavye</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Soğutucu</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Oyuncu Kulaklığı</li>
              
          
              </ul>
              
              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Telefon</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kulaklık</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Cep Telefonu</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kılıf</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'> Kırılmaz Cam</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Powerbank</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Şarj Cihazları</li>

                  
          
              </ul>
              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Tv & Ses</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Televizyon</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Media Player</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Hoparlör</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Soundbar</li>

          
              </ul>

          </div>

          <div className='p-2 md:p-3 lg:p-4 space-x-2 grid grid-cols-2 md:grid-cols-4'>
              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Beyaz Eşya</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Buzdolabı</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline truncate'>Çamaşır Makinası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Bulaşık Makinası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Kurutma Makinası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Deri Dondurucu</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Klima</li>
            
          
              </ul>

              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Kişisel Bakım</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Saç Düzleştirici</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tıraş Makinası</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Saç Maşası </li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Epilasyon Aleti</li>
           
              
          
              </ul>
              
              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Elektronik Aksesuar</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Bilgisayar </li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Telefon Aksesuarları</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Tv Aksesuarları</li>

                  
          
              </ul>
              <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
                  <h6 className='text-xs  md:text-sm font-500 text-gray-300 underline'>Oyun</h6>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Playstation</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Nintendo</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Xbox</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Playstation Oyunları</li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Oyuncu Bilgisayarı </li>
                  <li className='hover:text-violet-700 duration-500 hover:underline'>Oyuncu  Koltukları</li>


           
          
              </ul>

          </div>
      </div>
    </div>

  </div>
  )
}

export default Electronic
